<template>
  <div class="root_profile flex-col scaler_profile">
    <div class="block_1 flex-row">
      <div class="group_1 flex-col">
        <div class="image-wrapper_1 flex-row" @click="editUsrname = true" style="cursor: pointer;">
          <img v-if="!editUsrname" class="label_1" referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG16fbb436b79a47dce60e4431f1573fb8.png" />
        </div>
        <div class="section_1 flex-row">
          <div class="image-text_1 flex-col justify-between">
            <template v-if="!previewAvata">
              <img class="image_1" referrerpolicy="no-referrer" :src="avatar" @click="openFileInput" />
            </template>
            <template v-else>
              <img class="label_1" referrerpolicy="no-referrer" :src="previewAvatar" @click="openFileInput" />
            </template>



            <el-input v-if="editUsrname" v-model="nickname" @keyup.enter.native="editUsrname = false"
              @blur="editUsrname = false"></el-input>
            <span v-else class="text-group_1">{{ nickname }}</span>
          </div>
        </div>
        <div class="section_2 flex-row">
          <div class="text-wrapper_1 flex-col justify-between">
            <span class="text_1">微信号</span>
            <span class="text_2">手机号</span>
          </div>
          <span class="text_3">{{ mobile }}</span>
          <div class="text-group_2 flex-col justify-between">
            <span class="text_4">
              <router-link to="/store/dashboard/QRCode">&gt;</router-link>
            </span>
            <span class="text_5">
              <router-link to="/store/dashboard/phone">&gt;</router-link>
            </span>
          </div>
        </div>
        <div class="text-wrapper_2 flex-row">
          <span class="text_6">密码</span>
          <span class="text_7">*****************</span>
          <span class="text_8">
            <router-link to="/store/dashboard/password">&gt;</router-link>
          </span>
        </div>
        <div class="section_3 flex-row justify-between">
          <div class="text-wrapper_3 flex-col" style="cursor: pointer;"><span class="text_9"
              @click="modifyInfo">&nbsp;确认</span>
          </div>
          <div class="text-wrapper_4 flex-col" style="cursor:pointer"><span class="text_10"
              @click="cancelEdit">取消</span></div>
        </div>
      </div>
      <input type="file" ref="fileInput" accept="image/*" @change="handleFileChange" style="display: none;" />
    </div>
  </div>
</template>
<script>
import { getUserInfo, updateUser } from '@/api/user';
import { uploadImg } from '@/api/upload';

export default {
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      nickname: '',
      editUsrname: false,
      editAvatar: false,
      avatar: require('./assets/img/FigmaDDSSlicePNGac346a9eb533a031e4f7c0edbf3072af.png'),
      previewAvatar: null,
      mobile: '',
      file: null
    };
  },
  methods: {
    async modifyInfo() {
      if (this.editAvatar && this.file) {
        try {
          // 上传头像到指定目录
          const res = await uploadImg('avatars', this.file);
          if (res.data.code === 1) {
            this.avatar = res.data.data.url; // 更新头像 URL
            this.editAvatar = false; // 关闭编辑状态
          } else {
            this.$message.error('上传失败');
            return;
          }
        } catch (error) {
          console.error('上传失败:', error);
          this.$message.error('上传失败，请稍后重试');
          return;
        }
      }

      try {
        const res = await updateUser({
          avatar: this.avatar,
          nickname: this.nickname
        });

        const { code, msg, data } = res.data;
        if (code !== 1) {
          this.$message.error(msg || '操作失败');
          return;
        }

        this.$message.success('修改成功');

        // 更新用户信息
        const userInfo = await this.$store.dispatch('user/getInfo');
        localStorage.setItem('userInfo', JSON.stringify(userInfo?.data || {}));
      } catch (error) {
        console.error('修改失败:', error);

        const errorMsg = error.response?.data?.msg
          || error.message
          || '请求异常，请稍后重试';

        this.$message.error(errorMsg);
      }
    },
    async getInfo() {
      let res = await getUserInfo();
      if (res.data.code == 1) {
        this.nickname = res.data.data.nickname;
        this.avatar = res.data.data.avatar;
        this.mobile = res.data.data.mobile;
      } else if (res.data.code == -1) {
        this.$message({
          message: '登录状态失效将在2S后重新登录',
          type: 'error',
        });

        await new Promise((resolve) => setTimeout(resolve, 3000));
        await this.$store.dispatch('user/logout');
      }
    },
    cancelEdit() {
      this.$emit('close-dialog');
      this.editUsrname = false;
      this.editAvatar = false;
    },
    openFileInput() {
      if (!this.editUsrname) {
        this.editAvatar = true;  // 开启头像编辑状态
        this.$refs.fileInput.click();  // 触发文件选择
      }
    },
    handleFileChange(e) {
      const file = e.target.files[0];
      if (file) {
        this.file = file;  // 保存文件对象
        const reader = new FileReader();
        reader.onload = (event) => {
          this.previewAvatar = event.target.result;  // 更新头像预览
        };
        reader.readAsDataURL(file);
      }
    }
  },
  mounted() {
    this.getInfo();
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
/* 注意避免类选择器重名 */
.scaler_profile {
  transform-origin: top left;
  transform: scale(0.75);
}

.el-input {
  border: solid 2px;
  border-image: linear-gradient(90deg,
      rgba(126, 180, 235, 1) 0,
      rgba(177, 110, 249, 1) 100%) 1;
}

::v-deep .el-input__inner {
  text-align: center;
  background: transparent;
  font-size: x-large;
}
</style>
